import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { Link } from 'react-router-dom';


const styles = {
  root: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
};

class ButtonAppBar extends React.Component {


  render () {
    const MyLink = props => <Link to="/dashboard" {...props} />

    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <AppBar position="static">
          <Toolbar style={{flexDirection: 'row', justifyContent: 'space-between'}}>
            {/*<IconButton className={classes.menuButton} color="inherit" aria-label="Menu">
              <MenuIcon />
            </IconButton>*/}
            {/* <Typography onClick={() => this.routeChange('/dashboard')} variant="h6" color="inherit" >
              Wheres My Art?
          </Typography> */}
          <Button component={MyLink}>
            Another Link
          </Button>
            <Button style={{onHover: { color: 'white '}}} component={Link} to="/dashboard" color="inherit">Wheres My Art?</Button>
            {/* <Button color="inherit">Dashboard</Button> */}
            <Button component={Link} to="/dashboard" color="inherit">My Account</Button>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

ButtonAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ButtonAppBar);